import { IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import { useState } from 'react'

type Props = {
  /** Scaling step added or subtracted each time the zoom in or zoom out buttons are clicked. */
  step: number
  onChange: (nextScale: number) => void
  onOpenDetails?: () => void
}

export const TimelineScaleControls = ({
  step,
  onChange,
  onOpenDetails,
}: Props) => {
  const translate = useTranslate()
  const [currentScale, setCurrentScale] = useState(1)

  const handleChangeScale = (nextScale: number) => () => {
    if (nextScale >= 1) {
      setCurrentScale(nextScale)
      onChange(nextScale)
    }
  }

  return (
    <div
      className={cx(
        'absolute right-0 hidden group-hover:flex!',
        paperStyles({ isFaded: true }),
      )}
    >
      <IconButton
        tip={translate('action.zoomIn')}
        iconName="MagnifyingGlassPlus"
        iconSize="md"
        onClick={handleChangeScale(currentScale + step)}
      />
      <IconButton
        tip={translate('action.zoomOut')}
        iconName="MagnifyingGlassMinus"
        iconSize="md"
        onClick={handleChangeScale(currentScale - step)}
      />
      <IconButton
        tip={translate('action.zoomReset')}
        iconName="ArrowPath"
        iconSize="md"
        onClick={handleChangeScale(1)}
      />
      {onOpenDetails && (
        <IconButton
          tip={translate('action.zoomOpen')}
          iconName="ArrowTopRightOnSquare"
          iconSize="md"
          onClick={onOpenDetails}
        />
      )}
    </div>
  )
}
